/* eslint react/prop-types: 0 */

import React from 'react';
import image from '../assets/images/demo.png';

const Features = () => {
  return (
    <div className="signup__features">
      <img src={image} alt="Lanbilling" className="image" />
    </div>
  );
};

export default Features;
